import { Heading2XL, Heading3XL } from "../../../typography";

import { Fragment } from "react";
import { GridCard } from "../../components/ui/GridCard";
import { testimonials } from "../config/lifeAtVerseConfig";

export const TeamsWordsSection = () => {
  return (
    <div className="tw-z-20 tw-mx-auto tw-mt-[5em] tw-flex tw-max-w-[1400px] tw-flex-col tw-items-center tw-justify-center tw-gap-[1em] tw-px-[1.25em] min440:tw-mt-[7.5em] min440:tw-px-[6.25em]">
      <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center">
        <Heading3XL className="tw-my-0 tw-hidden tw-text-blue-dark-3 min440:tw-flex">
          In the team's words
        </Heading3XL>
        <Heading2XL className="tw-my-0 tw-text-blue-dark-3 min440:tw-hidden">
          In the team's words
        </Heading2XL>
      </div>

      <div className="tw-grid-rows-14 tw-mb-[7.5em] tw-hidden tw-grid-cols-12 tw-gap-[1em] tw-p-[15px] min1040:tw-grid">
        <GridCard
          testimonial={testimonials[0]}
          className="tw-col-span-4 tw-row-span-6"
        />
        <div className="tw-col-span-4 tw-row-span-4">
          <img
            src="landing_page_assets/about/About12.png"
            alt="testimonial3"
            className="tw-h-full tw-w-full tw-rounded-[1.5em] tw-object-cover"
          />
        </div>

        <GridCard
          testimonial={testimonials[1]}
          className="tw-col-span-4 tw-row-span-6 tw-grid tw-gap-[10px]"
        />

        <GridCard
          testimonial={testimonials[2]}
          className="tw-col-span-4 tw-row-span-6 tw-grid tw-gap-[10px]"
        />

        <div className="tw-col-span-4 tw-row-span-8 tw-overflow-hidden">
          <img
            src="landing_page_assets/about/About11.png"
            alt="testimonial4"
            className="tw-h-full tw-w-full tw-rounded-[1.5em]"
          />
        </div>
        <div className="tw-col-span-4 tw-row-span-4">
          <img
            src="landing_page_assets/about/About13.png"
            alt="testimonial3"
            className="tw-h-full tw-w-full tw-rounded-[1.5em] tw-object-cover"
          />
        </div>

        <GridCard
          testimonial={testimonials[3]}
          className="tw-col-span-8 tw-row-span-4"
        />
      </div>

      {/* MOBILE */}
      <div className="tw-mb-[5em] tw-flex tw-h-fit tw-w-full tw-gap-[1em] tw-overflow-x-scroll min1040:tw-hidden">
        {testimonials.map((testimonial) => (
          <Fragment key={testimonial.text}>
            <GridCard
              testimonial={testimonial}
              className="tw-shrink-0 tw-basis-[85%] tw-overflow-y-hidden min840:tw-basis-[32%]"
            />
          </Fragment>
        ))}
      </div>
    </div>
  );
};
